import { Autocomplete, DatePicker, Field, Text, TextField } from "components/commons";
import styles from "./delivery-log.module.scss";
import { useFormContext } from "contexts/form-context";
import moment from "moment";
import TimePickerV2 from "components/commons/time-picker/time-picker-v2";
import { deliveryLogRecipient } from "data/constant/delivery-log";
import { SelectShiftsPaginated } from "components/field";
import locale from "localization";
import { useMemo } from "react";
import EmployeePositionEnum from "enums/employee-position";
import { ShiftStatus } from "enums";

const DeliveryInformationForm = ({ deliveryLog }) => {
  const { fields, modifyField, modifyForm } = useFormContext();

  const isDateToday = useMemo(
    () => moment(fields.date.value).format("YYYY-MM-DD") === moment().format("YYYY-MM-DD"),
    [fields.date.value],
  );

  return (
    <>
      <Text strong color={"black"} className={styles.sectionTitle}>
        {locale.deliveryInformation}
      </Text>
      <Field
        {...fields.recipient}
        label={locale.deliveryRecipient}
        labelClassName={styles.fieldLabel}
        childrenClassName={styles.fieldContent}
      >
        <Autocomplete
          {...fields.recipient}
          onChange={modifyField}
          options={deliveryLogRecipient.map((val) => ({
            label: val,
            value: val?.toLowerCase(),
          }))}
          Component={Autocomplete}
        />
      </Field>
      <Field
        {...fields.shiftId}
        label={locale.shift}
        labelClassName={styles.fieldLabel}
        childrenClassName={styles.fieldContentShift}
      >
        <SelectShiftsPaginated
          {...fields.shiftId}
          placeholder={locale.selectShift}
          isHideBankDeposit={false}
          isFlattenedRecord={true}
          shiftStatus={[ShiftStatus.Started, ShiftStatus.Ended]}
          disableAllOption
          onChange={(_, { value, label, name, shift }) => {
            modifyForm({
              [name]: {
                value: value,
                label,
              },
              cashier: {
                value: shift?.employees?.find(
                  (e) => e?.label?.toLowerCase() === EmployeePositionEnum?.CASHIER,
                )?.name,
              },
              products: {
                value: [],
              },
            });
          }}
        />
      </Field>

      <div className={styles.dateRow}>
        <Field
          {...fields.date}
          labelClassName={styles.fieldLabel}
          childrenClassName={styles.fieldContent}
        >
          <DatePicker
            {...fields.date}
            prettify={(date) => moment(date).format("YYYY-MM-DD HH:mm")}
            onChange={modifyField}
            Component={DatePicker}
            disableEndDate={new Date()}
          />
        </Field>
        <Field
          {...fields.time}
          labelClassName={styles.fieldLabel}
          childrenClassName={styles.fieldContent}
        >
          <TimePickerV2
            {...fields.time}
            variant={"purple"}
            onChange={modifyField}
            maxTime={isDateToday ? new Date() : undefined}
            date={fields.date.value}
          />
        </Field>
      </div>
      <div className={styles.dateRow}>
        <Field
          {...fields.poReferenceNumber}
          labelClassName={styles.fieldLabel}
          childrenClassName={styles.fieldContent}
        >
          <TextField {...fields.poReferenceNumber} onChange={modifyField} />
        </Field>
        <Field
          {...fields.plateNumber}
          labelClassName={styles.fieldLabel}
          childrenClassName={styles.fieldContent}
        >
          <TextField {...fields.plateNumber} onChange={modifyField} />
        </Field>
      </div>
    </>
  );
};

export default DeliveryInformationForm;
